import React, { useEffect, useRef } from 'react'
import { getCookie } from '../../utils/cookies'

const RS_SCRIPT_URL = 'https://cdn-eu.readspeaker.com/script/5275/webReader/webReader.js?pids=wr&disable=dictionary,pagemask'

let scriptInjected = false
let scriptLoaded = false

function injectReadSpeakerScript(): void {
  if (scriptInjected) return
  scriptInjected = true

  // rsConf must be set before the script loads
  window.rsConf = {
    settings: { hlspeed: 100 },
    general: { usePost: true, popupCloseTime: 3000, enableSkipAlways: true },
    params: '//cdn-eu.readspeaker.com/script/5275/webReader/webReader.js?pids=wr',
    cb: {
      ui: {
        open: function () { },
        play: function () { }
      }
    }
  }

  const script = document.createElement('script')
  script.id = 'rs_req_Init'
  script.src = RS_SCRIPT_URL
  script.async = true
  script.onload = () => { scriptLoaded = true }
  document.body.appendChild(script)
}

function configureReadSpeakerPhrases(): void {
  try {
    window.ReadSpeaker.q(function () {
      const listenStr = 'Luister'
      const translateStr = 'Translate'
      if (window.rspkr.phrases) {
        const langKey = window.rspkr.mapLang('nl_nl')
        const listenKey = window.rspkr.mapPhrase('translation')
        const translateKey = window.rspkr.mapPhrase('listen')
        for (let i = 0; i < window.rspkr.phrases.length; i++) {
          if (window.rspkr.phrases[i].substr(0, 3) === langKey + listenKey) { window.rspkr.phrases[i] = listenStr }
          if (window.rspkr.phrases[i].substr(0, 3) === langKey + translateKey) { window.rspkr.phrases[i] = translateStr }
        }
      } else {
        const updatedPhrases = { nl_nl: { listen: listenStr, translation: translateStr } }
        window.rspkr.cfg.extendPhrases(updatedPhrases)
      }
    })
  } catch (e) {
    console.error('ReadSpeaker phrase configuration failed', e)
  }
}

export const Readspeaker = () =>
  getCookie('readspeaker-cookies') === 'yes' ? (
    <ReadSpeakerButton />
  ) : (
    <> </>
  )

export const reAdEvents = () => {
  if (window?.ReadSpeaker?.q == null) {
    return false
  }

  window.ReadSpeaker.q(function () { if (window.rspkr.ui.getActivePlayer()) { window.rspkr.ui.getActivePlayer().close(); } })
  window.ReadSpeaker.q(function () { window.rspkr.ui.addClickEvents(); })
  return true
}

function ReadSpeakerButton() {
  const configuredRef = useRef(false)

  useEffect(() => {
    // Inject the external script (only once across all instances)
    injectReadSpeakerScript()

    const tryInit = () => {
      if (!reAdEvents()) return false
      if (!configuredRef.current) {
        configuredRef.current = true
        configureReadSpeakerPhrases()
      }
      return true
    }

    // If the script is already loaded, bind immediately
    if (tryInit()) return

    // Otherwise poll until the script has loaded
    const interval = setInterval(() => {
      if (tryInit()) clearInterval(interval)
    }, 200)

    return () => clearInterval(interval)
  })

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.defaultPrevented) {
      // ReadSpeaker's native handler already processed this click
      return
    }
    // Prevent the browser from navigating to the fallback MP3 URL
    e.preventDefault()

    // If ReadSpeaker is loaded, re-bind events and trigger playback
    if (window?.ReadSpeaker?.init) {
      window.ReadSpeaker.init()
    }
  }

  return (
    <div id="readspeaker_button1" className="rs_skip rsbtn rs_preserve">
      <a
        rel="nofollow"
        className="rsbtn_play"
        accessKey="L"
        title="Laat de tekst voorlezen met ReadSpeaker webReader"
        href={`https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=5275&lang=nl_nl&readid=a11y-main&url=${encodeURIComponent(window.location.href)}`}
        onClick={handleClick}
      >
        <span className="rsbtn_left rsimg rspart">
          <span className="rsbtn_text">
            <span>Lees voor</span>
          </span>
        </span>
        <span className="rsbtn_right rsimg rsplay rspart"></span>
      </a>
    </div>
  )
}
